const q = require('queried');

const {
  Model,
} = require('./core');

const {
  FacetController,
  FacetFilter,
  FlatFacetFilter,
  TagsFacetFilter,
  VoidFacetController,
  VoidFacetFilter,
  FacetFilterClear,
} = require('./facet-filter');

const {
  FeedController,
  FeedLayout,
  CityController,
  CityLayout,
  SearchResultListController,
  SearchLayout,
} = require('./feed-layout');

const {
  NavigationController,
  NavigationView,
} = require('./navigation');

const {
  TitleController,
  Title,
} = require('./title');

const {
  LoadMoreController,
  LoadMore,
} = require('./load-more');

const {
  Search,
  SearchController,
} = require('./search');

const {
  SubwayStations,
  SubwayController,
} = require('./subway');

const kudago = require('../kudago');

const feedEl = q('.feed:not(.feed-my-anything)');
let model;

if (feedEl && !feedEl.closest('.profile-content')) {
  model = new Model({
    page: {
      originUrl: kudago.originUrl || window.location.pathname,
      title: getPageHeader(),
    },
  });

  if (feedEl.closest('.search-results-container')) {
    new SearchResultListController(model, new SearchLayout(model, feedEl));
  } else if (feedEl.classList.contains('city-feed')) {
    new CityController(model, new CityLayout(model, feedEl));
  } else {
    new FeedController(model, new FeedLayout(model, feedEl));
  }

  q.all('.facet').forEach((facet) => {
    if (q('[data-void="true"]', facet)) {
      new VoidFacetController(model, new VoidFacetFilter(model, facet));
    } else if (!facet.closest('.facet-tags')) {
      if (facet.closest('.flat-filters')) {
        new FacetController(model, new FlatFacetFilter(model, facet));
      } else {
        new FacetController(model, new FacetFilter(model, facet));
      }
    }
  });

  q.all('.facet-tags').forEach((tags) => {
    new FacetController(model, new TagsFacetFilter(model, tags));
  });

  q.all('.navbar-mix').forEach((navBar) => {
    new NavigationController(model, new NavigationView(model, navBar));
  });

  q.all(`
    .feed-container .load-more-button,
    .search-results-container .load-more-button
  `).forEach((button) => {
    new LoadMoreController(model, new LoadMore(model, button));
  });

  q.all('.search-header').forEach((search) => {
    new SearchController(model, new Search(model, search));
  });

  q.all('.subway-search-container').forEach((subwayContainer) => {
    new SubwayController(model, new SubwayStations(model, subwayContainer));
  });

  q.all('.clear-filters-container').forEach((element) => {
    new FacetController(model, new FacetFilterClear(model, element));
  });

  new TitleController(model, new Title(model));
}

function getPageHeader() {
  const h1 = q('.stext h1');
  return h1 ? h1.innerHTML : document.title;
}

module.exports = model;
